import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import GenericBulten from 'src/components/GenericBulletin';

const useStyles = makeStyles((theme) => ({
  root: {},
  button: {
    margin: theme.spacing(0.2),
  },
}));


function GenericBulletinDialog(allProps) {
  let { setProps, ...props } = allProps

  const classes = useStyles();

  return (
    <Dialog
      open={props.open}
      onClose={() => setProps({ ...props, open: false })}
      keepMounted
    >
      <DialogTitle id="alert-dialog-title">
        Malzemeye Ait Bültenler
        </DialogTitle>
      <DialogContent>
        <GenericBulten param={props.materialCode} />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setProps({ ...props, open: false })}
          className={classes.button}
          endIcon={<CloseIcon />}
        >
          Kapat
          </Button>
      </DialogActions>
    </Dialog>
  );
}

export default GenericBulletinDialog;

